import React from 'react';
import { IconProps } from '.';

export const Workplan = ({
  className,
  color = '#7D7A9A',
  width = '21',
  height = '21',
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_181_52404"
      className="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
    >
      <rect x="0.852051" y="0.849487" width="20" height="20" fill={color} />
    </mask>
    <g mask="url(#mask0_181_52404)">
      <path
        d="M10.8521 9.18282H15.0187V7.51615H10.8521V9.18282ZM10.8521 14.1828H15.0187V12.5162H10.8521V14.1828ZM8.35205 10.0162C8.81038 10.0162 9.20288 9.85282 9.52955 9.52615C9.85566 9.20004 10.0187 8.80782 10.0187 8.34949C10.0187 7.89115 9.85566 7.49865 9.52955 7.17199C9.20288 6.84588 8.81038 6.68282 8.35205 6.68282C7.89372 6.68282 7.50149 6.84588 7.17538 7.17199C6.84872 7.49865 6.68538 7.89115 6.68538 8.34949C6.68538 8.80782 6.84872 9.20004 7.17538 9.52615C7.50149 9.85282 7.89372 10.0162 8.35205 10.0162ZM8.35205 15.0162C8.81038 15.0162 9.20288 14.8531 9.52955 14.527C9.85566 14.2003 10.0187 13.8078 10.0187 13.3495C10.0187 12.8912 9.85566 12.4987 9.52955 12.172C9.20288 11.8459 8.81038 11.6828 8.35205 11.6828C7.89372 11.6828 7.50149 11.8459 7.17538 12.172C6.84872 12.4987 6.68538 12.8912 6.68538 13.3495C6.68538 13.8078 6.84872 14.2003 7.17538 14.527C7.50149 14.8531 7.89372 15.0162 8.35205 15.0162ZM5.01872 18.3495C4.56038 18.3495 4.16788 18.1864 3.84122 17.8603C3.51511 17.5337 3.35205 17.1412 3.35205 16.6828V5.01615C3.35205 4.55782 3.51511 4.16532 3.84122 3.83865C4.16788 3.51254 4.56038 3.34949 5.01872 3.34949H16.6854C17.1437 3.34949 17.5362 3.51254 17.8629 3.83865C18.189 4.16532 18.3521 4.55782 18.3521 5.01615V16.6828C18.3521 17.1412 18.189 17.5337 17.8629 17.8603C17.5362 18.1864 17.1437 18.3495 16.6854 18.3495H5.01872ZM5.01872 16.6828H16.6854V5.01615H5.01872V16.6828Z"
        fill={color}
      />
    </g>
  </svg>
);
